import i18n from "../../../../constants/i18n";
import { getKhattabatResultsStore } from "../../../../stores/khattabat-stores/results-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";

const EnableDisableConversation = withLiteObserverAndTheme<{
  matchID: number;
  isDisabled: boolean;
}>((props) => {
  const { theme, matchID, isDisabled } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={150}
      height={35}
      color={colors.all.transparent}
      style={{
        borderRadius: 10 * unitX,
        backgroundColor: isDisabled ? colors.all.green : colors.all.red,
        cursor: "pointer"
      }}
      onClick={async () => {
        await getKhattabatResultsStore().disableEnableMatchConversationDatabase(
          {
            matchIDs: [matchID],
            enableAllConversations: false,
            disableAllConversations: false
          }
        );
      }}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={15}
        isSpan={true}
        text={i18n.get(isDisabled ? "ENABLE" : "DISABLE")}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 30 * unitY,
          width: "100%"
        }}
        color={colors.all.white}
      />
    </ET3Div>
  );
});

export default EnableDisableConversation;
